/* 布局 */
//前台
import Layout from "@views/layout";

const cooperatebusinesscolumndirectoryRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "cooperatebusinesscolumndirectory",
            name: "COOPERATEBUSINESSCOLUMNDIRECTORY",
            meta: {
                title: "企业栏目目录",
                sort: 1,
            },
            component: () => import("@views/business/cooperatebusinesscolumndirectory/index.vue"),
            redirect: {
                name: "COOPERATEBUSINESSCOLUMNDIRECTORY_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "COOPERATEBUSINESSCOLUMNDIRECTORY_LIST",
                    meta: {
                        title: "企业栏目目录",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/cooperatebusinesscolumndirectory/list.vue"),
                },
                                {
                    path: "add",
                    name: "COOPERATEBUSINESSCOLUMNDIRECTORY_ADD",
                    meta: {
                        title: "新增合作-企业栏目目录",
                        parentPath: '/business/cooperatebusinesscolumndirectory/list',
                        operate: true,
                    },
                    component: () => import("@views/business/cooperatebusinesscolumndirectory/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "COOPERATEBUSINESSCOLUMNDIRECTORY_EDIT",
                    meta: {
                        title: "编辑合作-企业栏目目录",
                        parentPath: '/business/cooperatebusinesscolumndirectory/list',
                        operate: true,
                    },
                    component: () => import("@views/business/cooperatebusinesscolumndirectory/form.vue"),
                },
                                        ],
    },


        ],
};

export default cooperatebusinesscolumndirectoryRouter;
